import { App } from 'vue';
import { createApp } from 'vue-demi'
import DialogInstance from './index.vue';
import { DialogProps } from 'element-plus'

let dialogType: {
  title?: string
  content: () => any,
  props?: Partial<DialogProps>
} = {
  content: () => undefined,
}

type DialogType = Partial<typeof dialogType>;
let SingleInstance: Record<string, ReturnType<typeof createApp>> = {}
function dialog(value: DialogType = dialogType, key = 'default'): Promise<any> {
  if (SingleInstance[key]) return Promise.resolve([{ msg: '已唤起' }]);
  return new Promise(async function (r, re) {
    const rootEl = document.createElement('div')
    document.body.appendChild(rootEl)
    value = Object.assign({ content: '', }, value, {
      reject(arg) {
        re(arg)
        SingleInstance[key].unmount()
        delete SingleInstance[key];
        rootEl.remove()
      },
      resolve(arg) {
        r(arg)
        SingleInstance[key].unmount()
        delete SingleInstance[key];
        rootEl.remove()
      }
    });
    const plugins = await import('@/plugins');
    const vueInstance = createApp(DialogInstance, value)
    SingleInstance[key] = vueInstance;
    await plugins.plugins(vueInstance)
    vueInstance.mount(rootEl);
  })
}

function install(app: App) {
  app.config.globalProperties.$dialog = dialog;
}

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    $dialog: typeof dialog
  }
}
export {
  dialog
}
export default {
  install: install
}
